/**
 * Where a notification's `deepLink` goes in this app.
 *
 * The server writes full paths - `/shows/{showId}?tab=home&post={postId}` -
 * which are the app's own routes and are used as they are. A bare suffix
 * (`?tab=rehearsals`, `/settings`) is taken as relative to the
 * notification's show. Prefixing the show unconditionally, as this used to,
 * turned every full path into `/shows/{id}/shows/{id}?...` - a page that
 * does not exist, so clicking a notification went nowhere.
 *
 * public/firebase-messaging-sw.js carries a copy of this rule (a service
 * worker cannot import from the bundle); keep the two in step.
 */
export const resolveDeepLink = (rawLink: string, showId?: string): string => {
  // Browsers read a leading `//` or `/\` as another host, so any run of
  // leading slashes or backslashes becomes one: a link can only ever name a
  // page in this app.
  const deepLink = rawLink.replace(/^[\\/]+/, '/');
  // The dashboard root with a section (`/?section=reporting&report=r1`,
  // `/?section=messages&channel=...`) is a full path too - not a suffix of
  // the show, which turned it into a show page that has no such section.
  if (deepLink.startsWith('/shows/') || deepLink.startsWith('/?') || (!showId && deepLink.startsWith('/'))) {
    return deepLink;
  }
  if (!showId) return `/${deepLink}`;
  const suffix = deepLink.startsWith('/') || deepLink.startsWith('?') ? deepLink : `/${deepLink}`;
  return `/shows/${showId}${suffix}`;
};
